import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

import { TasksService } from '../../services/tasks/tasks.service';
import { TaskDetailsComponent } from '../task-details/task-details.component';

@Component({
  selector: 'app-view-tasks',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    ToastModule,
  ],
  providers: [MessageService, DialogService],
  templateUrl: './view-tasks.component.html',
  styleUrls: ['./view-tasks.component.scss']
})
export class ViewTasksComponent implements OnInit {
  private _tasksService = inject(TasksService);
  private _dialogService = inject(DialogService);
  private _messageService = inject(MessageService);
  public config = inject(DynamicDialogConfig);
  public ref = inject(DynamicDialogRef);

  actionPlan: any;
  tasks: any[] = [];
  loading: boolean = false;

  totalTasks: number = 0;
  tasksTodo: number = 0;
  tasksInProgress: number = 0;
  tasksDone: number = 0;

  percentageTodo: number = 0;
  percentageInProgress: number = 0;
  percentageDone: number = 0;

  private taskDetailsDialogRef: DynamicDialogRef | undefined;

  ngOnInit(): void {
    this.actionPlan = this.config.data.actionPlan;
    this.loadTasks();
  }

  loadTasks(): void {
    if (!this.actionPlan?.id) {
      this._messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener el ID del plan de acción'
      });

      return;
    }

    this.loading = true;

    const filters = {
      action_plan: this.actionPlan.id,
      page: 1,
      page_size: 100
    };

    this._tasksService.getTasks(filters).subscribe({
      next: (response) => {
        this.tasks = Array.isArray(response) ? response : response.items || [];
        this.totalTasks = this.tasks.length;
        this.calculateStatistics();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar las tareas del plan de acción'
        });
        console.error('Error loading tasks:', err);
      }
    });
  }

  calculateStatistics(): void {
    this.tasksTodo = this.tasks.filter(t => t.status?.key_string === 'task-todo').length;
    this.tasksInProgress = this.tasks.filter(t => t.status?.key_string === 'task-inprogress').length;
    this.tasksDone = this.tasks.filter(t => t.status?.key_string === 'task-done').length;

    if (this.totalTasks > 0) {
      this.percentageTodo = Math.round((this.tasksTodo / this.totalTasks) * 100);
      this.percentageInProgress = Math.round((this.tasksInProgress / this.totalTasks) * 100);
      this.percentageDone = Math.round((this.tasksDone / this.totalTasks) * 100);
    }
  }

  getStatusClass(status: any): string {
    if (status?.key_string === 'task-todo') return 'status-blue';
    if (status?.key_string === 'task-inprogress') return 'status-yellow';
    if (status?.key_string === 'task-done') return 'status-green';
    return 'status-blue';
  }

  viewTaskDetails(task: any): void {
    this.taskDetailsDialogRef = this._dialogService.open(TaskDetailsComponent, {
      header: `Detalles de la Tarea: ${task.folio}`,
      width: '90%',
      height: '90vh',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      data: {
        task: task
      }
    });

    this.taskDetailsDialogRef.onClose.subscribe(() => {
      this.loadTasks();
    });
  }

  close(): void {
    this.ref.close();
  }
}
